import { useEffect, useEffectEvent } from 'react'

/**
 * useDidMount hook
 * @description Calls a function on mount
 *
 * @param {Function} callback Callback function to be called on mount
 */
function useDidMount(callback: () => void): void {
  const onMount = useEffectEvent(callback)

  useEffect(() => {
    onMount()
  }, [])
}

export { useDidMount }
